/* eslint-disable prettier/prettier */
class MessageBox {
  constructor(options) {
    this.container = options.container;
    this.overlayName = options.overlayName;
    this._app = options.app;
    const me = this;

    this._app.overlayManager.register(
      this.overlayName,
      this.container,
      this.close.bind(this),
      true
    );

    const clickClose = function () {
      me.close();
    };

    this._app.elements.tw2018elem_msgClose.removeEventListener(
      "click",
      clickClose
    );
    this._app.elements.tw2018elem_msgClose.addEventListener(
      "click",
      clickClose
    );
  }

  open(msg, type) {
    const me = this;
    Promise.all([this._app.overlayManager.open(this.overlayName)]).then(() => {
      me._app.elements.tw2018elem_msg.textContent = msg;
      me._app.elements.tw2018elem_msgBox.style.display = "block";
      if (type === "error") {
        me._app.elements.tw2018elem_msgBox.classList.remove("tw2018css_info");
        me._app.elements.tw2018elem_msgBox.classList.add("tw2018css_error");
      } else {
        me._app.elements.tw2018elem_msgBox.classList.remove("tw2018css_error");
        me._app.elements.tw2018elem_msgBox.classList.add("tw2018css_info");
      }
    });
  }

  close() {
    this._app.overlayManager.close(this.overlayName);
  }
}

export { MessageBox };
